import { render, staticRenderFns } from "./PackageTemplateAssignModal.vue?vue&type=template&id=0bcc460b&scoped=true"
import script from "./PackageTemplateAssignModal.vue?vue&type=script&lang=js"
export * from "./PackageTemplateAssignModal.vue?vue&type=script&lang=js"
import style0 from "./PackageTemplateAssignModal.vue?vue&type=style&index=0&id=0bcc460b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcc460b",
  null
  
)

export default component.exports